<template>
    <div class="pushChannel-container">
        <div class="global_popup_header">{{$t('content.books.release')}}<i @click="$store.commit('windowHandle')"></i></div>
        <div class="global_popup_body">
            <p>{{$t('content.books.releaseTo')}}：</p>
            <div class="pushChannel-list" v-bar>
                <div>
                    <el-checkbox-group class="pushChannel-checkbox" v-model="checkedID">
                        <el-checkbox v-if="item.name !== 'UNPUBLIC' && !ancestorts.includes(item.name)" v-for="item in channelData" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
        </div>
        <div class="global_popup_footer">
            <button @click="confirm">{{$t('commonMsg.confirm')}}</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        channelData: {
            type:Array
        },
        ancestorts: {
            type:Array
        }
    },
    data() {
        return {
            checkedID: []
        }
    },
    methods: {
        confirm() {
            this.$emit('pushConfirm', this.checkedID)
            this.$store.commit('windowHandle')
        }
    }
}
</script>

<style lang="scss" scoped>
    .pushChannel-container{
        @include globalPopup(500px, 400px);
        .global_popup_body{
            display: flex;
            .pushChannel-list{
                flex:1;
                border:1px solid $globalBorderColor;
                border-radius: 4px;
                .pushChannel-checkbox{
                    padding:20px;
                    line-height: 30px;
                    display: flex;
                    flex-direction: column;
                }
            }
        }
        .global_popup_footer{
            padding-top:20px;
        }
    }
</style>
